<template>
  <Modal v-show="true" option="agree">
    <div class="p-modal__content__header">
      ご契約についての条項
    </div>
    <div class="p-modal__content__body">
      <p>
        本サービスのご契約にはGoogle ビジネスプロフィールのアカウントなどを管理するためのツールになります。<br>
        そのためGoogle ビジネスプロフィールのアカウントが必要になります。<br>
        Google ビジネスプロフィールのアカウントがない場合にはご利用になれませんので予めご了承ください。<br>
        契約期間は１年間となります（契約期間満了日の２か月前にお申し出なき限り、１年毎の自動更新となります）。<br>
        なお、お支払い頂いた代金について返金は行わないものとしますので予めご了承ください。
      </p>
      <button class="c-button__item c-button__item--outline-cancel c-close-btn" @click="$emit('close')">
        閉じる
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal'

export default {
  name: 'ClauseModal',
  components: {
    Modal,
  },
  emits: ['close']
}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../../stylesheets/biz_spa/foundation/_mixin.scss';

.p-modal--agree {
  .p-modal__content__body{
    height: 57vh;
    max-height: 382px;
    overflow: inherit;
    @include mq(sm) {
      height: 57vh;
      max-height: 256px;
    }
  }
  .c-close-btn {
    margin: 32px 0 32px auto;
  }
}
</style>
